export const userRonSurveyQuestions = [
  "How would you rate the overall RON session experience?",
  "How user-friendly was the application?",
  "How clear were the instructions provided during the notarization process?",
  "How satisfied are you with the speed of the notarization process?",
  "How would you rate your notary's professionalism?",
  "How likely are you to recommend Permit Rockstar?",
];

export const notaryRonSurveyQuestions = [
  "How smooth was the platform's setup for your notarization session?",
  "How easy was it to guide the user through the notarization process?",
  "How responsive was the platform during the RON session?",
  "How clear were the instructions provided for the notarization steps?",
  "How likely are you to continue working with Permit Rockstar for future sessions?",
  "How satisfied are you with the overall support from Permit Rockstar?",
];

export const userRonSurveyQuestionMapping = {
  0: "Experience",
  1: "Usability",
  2: "Clarity",
  3: "Speed",
  4: "Professionalism",
  5: "Recommendation",
};

export const notaryRonSurveyQuestionMapping = {
  0: "Setup",
  1: "Guidance",
  2: "Responsiveness",
  3: "Instructions",
  4: "Retention",
  5: "Support",
};

export const signerTitles = [
  "None",
  "Owner",
  "President",
  "CEO",
  "Manager",
  "Director",
  "Vice President",
  "Secretary",
  "Treasurer",
  "Partner",
  "Member",
  "Chairman",
  "Co-Owner",
  "Founder",
  "Co-Founder",
  "Managing Director",
  "Executive Director",
  "General Manager",
  "Operations Manager",
  "Supervisor",
  "Administrator",
  "Consultant",
  "Agent",
  "Trustee",
  "Attorney-in-Fact",
  "Representative",
  "Other",
];

export const authorityTypes = [
  "None",
  "Owner",
  "Agent",
  "Trustee",
  "Attorney-in-Fact",
  "Representative",
  "Guardian",
  "Executor",
  "Administrator",
  "Partner",
  "Member",
  "Manager",
  "Director",
  "Beneficiary",
  "General Partner",
  "Limited Partner",
  "Managing Partner",
  "Corporate Officer",
  "Power of Attorney Holder",
  "Legal Representative",
  "Supervisor",
  "Other",
];
